import { useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation } from "react-router";

import MiljokontrollDetalj from "./MiljokontrollDetalj";

import { getMiljokontroll as getMiljokontrollAction } from "../../../../actions/miljokontrollerActions";

import {
  formatDateHavingNorwegianDateTime,
  formatTimeHavingNorwegianDateTime,
} from "../../../../utils/date";

import sitePaths from "../../../../constants/sitePaths";

const getMiljogebyrLinkUrl = (miljokontroll, location) => {
  if (
    location.pathname.search(
      sitePaths.miljogebyrer.oversikt.detalj.miljokontroll.matcher,
    ) === 0
  ) {
    return sitePaths.miljogebyrer.oversikt.detalj.getUrl(
      miljokontroll.miljogebyrId,
    );
  } else if (
    location.pathname.search(
      sitePaths.miljogebyrer.tilBehandling.detalj.miljokontroll.matcher,
    ) === 0
  ) {
    return sitePaths.miljogebyrer.tilBehandling.detalj.getUrl(
      miljokontroll.miljogebyrId,
    );
  } else if (
    location.pathname.search(
      sitePaths.klage.miljogebyrer.detalj.miljokontroll.matcher,
    ) === 0
  ) {
    return sitePaths.klage.miljogebyrer.detalj.getUrl(
      miljokontroll.miljogebyrId,
    );
  } else if (
    location.pathname.search(
      sitePaths.miljogebyrer.miljokontrolloversikt.miljogebyrer.detalj
        .miljokontroll.detalj.matcher,
    ) === 0
  ) {
    return sitePaths.miljogebyrer.miljokontrolloversikt.miljogebyrer.detalj.getUrl(
      miljokontroll.miljogebyrId,
    );
  } else if (
    location.pathname.search(
      sitePaths.miljogebyrer.miljokontrolloversikt.detalj.matcher,
    ) === 0
  ) {
    return sitePaths.miljogebyrer.miljokontrolloversikt.detalj.miljogebyrer.detalj.getUrl(
      miljokontroll.id,
      miljokontroll.miljogebyrId,
    );
  }
  return null;
};

const buildMiljokontrollGridTableRows = (miljokontroll, location) => {
  if (!miljokontroll) {
    return [];
  }

  const to = miljokontroll.miljogebyrId
    ? getMiljogebyrLinkUrl(miljokontroll, location)
    : null;

  const ileggelsesnummer =
    miljokontroll && miljokontroll.miljogebyrId ? (
      <Link to={to}>
        {miljokontroll.ileggelsesnummer &&
          miljokontroll.ileggelsesnummer.toString()}
      </Link>
    ) : (
      ""
    );

  return [
    [
      {
        name: "Kontrollnummer",
        value: miljokontroll.nummer ? miljokontroll.nummer.toString() : "",
        description: "",
      },
      {
        name: "Dato",
        value: formatDateHavingNorwegianDateTime(miljokontroll.mottattDato),
        description: "",
      },
      {
        name: "Klokkeslett",
        value: formatTimeHavingNorwegianDateTime(miljokontroll.mottattDato),
        description: "",
      },
      {
        name: "Tjenestenummer",
        value: miljokontroll.tjenestenummer
          ? miljokontroll.tjenestenummer.toString()
          : "",
        description: "",
      },
      {
        name: "Overtredelseskode",
        value:
          miljokontroll.overtredelse1 && miljokontroll.overtredelse1.paragraf,
        description: "",
      },
      {
        name: "Ileggelsesnummer",
        value: ileggelsesnummer,
        description: "",
      },
    ],
    [
      { name: "Gatenavn", value: miljokontroll.gatenavn, description: "" },
      { name: "Gatenummer", value: miljokontroll.gatenummer, description: "" },
      { name: "Bydel", value: miljokontroll.bydel, description: "" },
      { name: "", value: "", description: "" },
      { name: "", value: "", description: "" },
      { name: "", value: "", description: "" },
    ],
    [
      { name: "Ved gate", value: miljokontroll.vedGate, description: "" },
      {
        name: "Ved gatenummer",
        value: miljokontroll.vedGatenummer,
        description: "",
      },
      {
        name: "Latitude",
        value: miljokontroll.latitude ? miljokontroll.latitude.toString() : "",
        description: "",
      },
      {
        name: "Longitude",
        value: miljokontroll.longitude
          ? miljokontroll.longitude.toString()
          : "",
        description: "",
      },
      { name: "", value: "", description: "" },
      { name: "", value: "", description: "" },
    ],
    [
      {
        name: "Antall observasjoner",
        value:
          miljokontroll.observasjoner &&
          miljokontroll.observasjoner.length.toString(),
        description: "",
      },
      { name: "", value: "", description: "" },
      { name: "", value: "", description: "" },
      { name: "", value: "", description: "" },
      { name: "", value: "", description: "" },
      { name: "", value: "", description: "" },
    ],
  ];
};

export default function MiljokontrollDetaljPage(props) {
  const location = useLocation();
  const dispatch = useDispatch();
  const miljokontroll = useSelector((state) => state.miljokontroll);
  const getMiljokontroll = useCallback(
    (id) => dispatch(getMiljokontrollAction(id)),
    [dispatch],
  );

  return (
    <MiljokontrollDetalj
      {...props}
      miljokontroll={miljokontroll}
      getMiljokontroll={getMiljokontroll}
      miljokontrollGridTableRows={buildMiljokontrollGridTableRows(
        miljokontroll,
        location,
      )}
    />
  );
}
